/**
 * Portal access policy — determines whether a user is allowed to use the portal.
 * Extracted from aws-amplify-auth.jsx for testability.
 *
 * @param {string} accountType - The user's account type from Cognito attributes
 * @param {string[]} groups - The user's Cognito groups
 * @returns {{ allowed: boolean, reason?: string }}
 */
export function checkPortalAccess(accountType, groups) {
  const allowedTypes = ['distributor', 'uploader', 'administrator'];
  const hasAllowedGroup = groups.some((g) => allowedTypes.includes(g));

  if (allowedTypes.includes(accountType) || hasAllowedGroup) {
    return { allowed: true };
  }

  return {
    allowed: false,
    reason: 'Unauthorized: this portal is restricted to distributors, uploaders, or administrators.',
  };
}

/**
 * Determines if a denied user should be redirected to the store.
 * Customer-type accounts are redirected; others get a generic error.
 *
 * @param {string} accountType - The user's account type
 * @returns {boolean}
 */
export function shouldRedirectToStore(accountType) {
  return accountType === 'customer';
}
